import React from "react"
import get from "lodash/get"
import Helmet from "react-helmet"
import Navigation from "../common/navigation"

import { Hero } from "../components/hero"
import Layout from "../common/layout"
import Subscribe from "../components/subscribe"

import Footer from "../common/footer"
import "./index.scss"

class ThankYou extends React.Component {
  render() {
    const siteTitle = get(this, "props.data.site.siteMetadata.title")

    return (
      <div className="contact-us-page">
        <Layout location={this.props.location}>
          <Navigation />
          <Helmet title="Swiftlane Terms of Use">
            <html lang="en" />
            <meta
              name="description"
              content="Swiftlane terms of use. Please take a moment to read through the Swiftlane terms of use. By using this website and our products, you agree to be bound by these terms."
            ></meta>
            <meta
              name="keywords"
              content="Swiftlane terms of use, terms of use"
            />
            <script
              async
              src="https://www.googletagmanager.com/gtag/js?id=AW-674518366"
            ></script>
            <script>
              {`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-674518366');
            `}
            </script>
          </Helmet>
          <div className="terms container">
            <div class="sqs-block-content">
              <h1>Terms of Use</h1>
              <p>
                <br />
              </p>
              <p>Effective Date: November 4th, 2019</p>
              <p>
                <br />
              </p>
              <p>
                PLEASE READ THESE TERMS BELOW CAREFULLY TO LEARN THE RULES AND
                RESTRICTIONS THAT GOVERN YOUR USE OF OUR WEBSITE(S), PRODUCTS,
                EQUIPMENT, SERVICES AND APPLICATIONS, INCLUDING MOBILE
                APPLICATIONS (COLLECTIVELY, THE “SERVICES”).&nbsp; THESE TERMS
                OF USE (THE “TERMS”) ARE A BINDING CONTRACT BETWEEN YOU AND
                SWIFTLANE, INC. (“Company”, “SWIFTLANE”, “WE”, “US”).&nbsp; YOUR
                USE OF THE SERVICES IN ANY WAY MEANS THAT YOU AGREE TO ALL OF
                THESE TERMS, AND THESE TERMS WILL REMAIN IN EFFECT WHILE YOU USE
                THE SERVICES.&nbsp; IF YOU ARE ACCEPTING THESE TERMS ON BEHALF
                OF A CORPORATION, LLC, PARTNERSHIP, EMPLOYER OR OTHER LEGAL
                ENTITY, YOU REPRESENT AND WARRANT THAT YOU ARE AUTHORIZED TO
                ENTER INTO THESE TERMS AND ACCEPT THESE TERMS ON BEHALF OF THAT
                ENTITY. THESE TERMS INCLUDE THE PROVISIONS IN THIS DOCUMENT, AS
                WELL AS THOSE IN THE{" "}
                <a href="htts://swiftlane.com/privacy">PRIVACY POLICY</a>.&nbsp;{" "}
                <strong>
                  YOUR USE OF OR PARTICIPATION IN CERTAIN SERVICES MAY ALSO BE
                  SUBJECT TO ADDITIONAL POLICIES, RULES AND/OR CONDITIONS
                  (“ADDITIONAL TERMS”), WHICH ARE INCORPORATED HEREIN BY
                  REFERENCE, AND YOU UNDERSTAND AND AGREE THAT BY USING OR
                  PARTICIPATING IN ANY SUCH SERVICES, YOU AGREE TO ALSO COMPLY
                  WITH THESE ADDITIONAL TERMS.
                </strong>
              </p>
              <p>
                <br />
              </p>
              <p>
                <strong>
                  These Terms include information about future changes to these
                  Terms, limitations of liability, a class action waiver and
                  resolution of disputes by arbitration instead of in
                  court.&nbsp; PLEASE NOTE THAT YOUR USE OF AND ACCESS TO OUR
                  SERVICES ARE SUBJECT TO THE FOLLOWING TERMS; IF YOU DO NOT
                  AGREE TO ALL OF THE FOLLOWING, YOU MAY NOT USE OR ACCESS THE
                  SERVICES IN ANY MANNER.
                </strong>
              </p>
              <p>
                <br />
              </p>
              <p>
                <strong>ARBITRATION NOTICE AND CLASS ACTION WAIVER: </strong>
                EXCEPT FOR CERTAIN TYPES OF DISPUTES DESCRIBED IN THE
                ARBITRATION AGREEMENT SECTION BELOW, YOU AGREE THAT DISPUTES
                BETWEEN YOU AND US WILL BE RESOLVED BY BINDING, INDIVIDUAL
                ARBITRATION AND YOU WAIVE YOUR RIGHT TO PARTICIPATE IN A CLASS
                ACTION LAWSUIT OR CLASS-WIDE ARBITRATION.
              </p>
              <p>
                <br />
              </p>
              <p>
                If you have any questions, comments, or concerns regarding the
                terms of the Services, please contact us at{" "}
                <a href="mailto:privacy@swiftlane.com">privacy@swiftlane.com</a>
                , or mail us at 65 Langton St, San Francisco, CA, 94013
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>PRIVACY</strong>
                <br />
              </h3>
              <p>
                Swiftlane takes the privacy of its users very seriously. For the
                current Privacy Policy, please click{" "}
                <a href="https://swiftlane.com/privacy">here</a>.
              </p>
              <p>
                <br />
              </p>
              <p>
                The Children’s Online Privacy Protection Act (“COPPA”) requires
                that online service providers obtain parental consent before
                they knowingly collect personally identifiable information
                online from children who are under 13.&nbsp; Swiftlane does not
                knowingly collect or solicit personally identifiable information
                from children under 13; if you are a child under 13, please do
                not attempt to register for or otherwise use the Services or
                send us any personal information.&nbsp; If we learn we have
                collected personal information from a child under 13, we will
                delete that information as quickly as possible.&nbsp; If you
                believe that a child under 13 may have provided us personal
                information, please contact us at{" "}
                <a href="mailto:contact@swiftlane.com">contact@swiftlane.com</a>
                .
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>CHANGES TO THE TERMS OF USE</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                We are constantly trying to improve our Services, so these Terms
                may need to change along with the Services.&nbsp; We reserve the
                right to change the Terms at any time, but if we do, we will
                place a notice on our site located at{" "}
                <a
                  href="https://swiftlane.com/"
                  hrefLang="en-us"
                  rel="alternate"
                >
                  https://swiftlane.com
                </a>
                , send you an email, and/or notify you by some other means.
              </p>
              <p>
                <br />
              </p>
              <p>
                If you don’t agree with the new Terms, you are free to reject
                them; unfortunately, that means you will no longer be able to
                use the Services.&nbsp; If you use the Services in any way after
                a change to the Terms is effective, that means you agree to all
                of the changes.
              </p>
              <p>
                <br />
              </p>
              <p>
                Except for changes by us as described here, no other amendment
                or modification of these Terms will be effective unless in
                writing and signed by both you and us.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>BASICS OF USING THE SERVICES</strong>
              </h3>
              <p>
                Swiftlane provides a platform that allows businesses and
                organizations (the “Organization”) to use their designated
                account to access the biometric and other information of their
                participants, employees, independent contractors, or other
                approved third parties, as applicable, for face recognition
                access control at the Organization’s locations.&nbsp; Swiftlane
                also allows the Organization’s participants, employees,
                independent contractors, or any third party authorized by the
                Organization (the “Individuals”) to access their designated
                account and input biometric and other information for the
                benefit of the Organization. &nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                You may be required to sign up for an account, select a password
                and user name (“Company User ID”), and provide us with certain
                information or data, such as your contact information.&nbsp; You
                promise to provide us with accurate, complete, and updated
                registration information about yourself.&nbsp; You may not
                select as your Company User ID a name that you don’t have the
                right to use, or another person’s name with the intent to
                impersonate that person. You may not transfer your account to
                anyone else without our prior written permission.
              </p>
              <p>
                <br />
              </p>
              <p>
                Additionally, you may be able to access certain parts or
                features of the Services by using your account credentials from
                other services (each, a “Third Party Account”), such as those
                offered by Google and Facebook. By using the Services through a
                Third Party Account, you permit us to access certain information
                from such account for use by the Services.&nbsp; You are
                ultimately in control of how much information is accessible to
                us and may exercise such control by adjusting your privacy
                settings on your Third Party Account.
              </p>
              <p>
                <br />
              </p>
              <p>
                You represent and warrant that you are of legal age to form a
                binding contract (or if not, you’ve received your parent’s or
                guardian’s permission to use the Services and gotten your parent
                or guardian to agree to these Terms on your behalf).&nbsp; If
                you’re agreeing to these Terms on behalf of an organization or
                entity, you represent and warrant that you are authorized to
                agree to these Terms on that organization or entity’s behalf and
                bind them to these Terms (in which case, the references to “you”
                and “your” in these Terms, except for in this sentence, refer to
                that organization or entity).
              </p>
              <p>
                <br />
              </p>
              <p>
                You will only use the Services for your own internal, personal,
                non-commercial use, and only in a manner that complies with all
                laws that apply to you.&nbsp; If your use of the Services is
                prohibited by applicable laws, then you aren’t authorized to use
                the Services.&nbsp; We can’t and won’t be responsible for your
                using the Services in a way that breaks the law.
              </p>
              <p>
                <br />
              </p>
              <p>
                You will not share your Company User ID, account or password
                with anyone, and you must protect the security of your Company
                User ID, account, password and any other access tools or
                credentials.&nbsp; You’re responsible for any activity
                associated with your Company User ID and account.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>TEXT MESSAGING AND EMAILS</strong>
                <br />
              </h3>
              <p>
                As part of the Services, you may receive communications through
                the Services, including messages that Swiftlane sends you (for
                example, via email or SMS). When signing up for the Services,
                you will receive a welcome message and instructions on how to
                stop receiving messages.{" "}
                <strong>
                  By signing up for the Services and providing us with your
                  wireless number, you confirm that you want Swiftlane to send
                  you information regarding your account or transactions with
                  us, which may include Swiftlane using automated dialing
                  technology to text you at the wireless number you provided,
                  and you agree to receive communications from Swiftlane, and
                  you represent and warrant that each person you register for
                  the Services or for whom you provide a wireless phone number
                  has consented to receive communications from Swiftlane.&nbsp;
                </strong>{" "}
                You agree to indemnify and hold Swiftlane harmless from and
                against any and all claims, liabilities, damages (actual and
                consequential), losses and expenses (including attorneys’ fees)
                arising from or in any way related to your breach of the
                foregoing.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>RESTRICTIONS</strong>
              </h3>
              <p>
                You represent, warrant, and agree that you will not contribute
                any Content or User Submission (each of those terms is defined
                below) or otherwise use the Services or interact with the
                Services in a manner that:
              </p>
              <p>
                <br />
              </p>
              <ol data-rte-list="default">
                <li>
                  <p>
                    (a) Infringes or violates the intellectual property rights
                    or any other rights of anyone else (including Company);
                  </p>
                </li>
                <li>
                  <p>
                    (b) Violates any law or regulation, including without
                    limitation, any applicable export control laws, privacy laws
                    or any other purpose not reasonably intended by Company;
                  </p>
                </li>
                <li>
                  <p>
                    (c) Is dangerous, harmful, fraudulent, deceptive,
                    threatening, harassing, defamatory, obscene, or otherwise
                    objectionable;
                  </p>
                </li>
                <li>
                  <p>
                    (d) Jeopardizes the security of your Company User ID,
                    account or anyone else’s (such as allowing someone else to
                    log in to the Services as you);
                  </p>
                </li>
                <li>
                  <p>
                    (e) Attempts, in any manner, to obtain the password,
                    account, or other security information from any other user;
                  </p>
                </li>
                <li>
                  <p>
                    (f) Violates the security of any computer network, or cracks
                    any passwords or security encryption codes;
                  </p>
                </li>
                <li>
                  <p>
                    (g) Runs Maillist, Listserv, any form of auto-responder or
                    “spam” on the Services, or any processes that run or are
                    activated while you are not logged into the Services, or
                    that otherwise interfere with the proper working of the
                    Services (including by placing an unreasonable load on the
                    Services’ infrastructure);
                  </p>
                </li>
                <li>
                  <p>
                    (h) “Crawls,” “scrapes,” or “spiders” any page, data, or
                    portion of or relating to the Services or Content (through
                    use of manual or automated means);
                  </p>
                </li>
                <li>
                  <p>
                    (i) Copies or stores any significant portion of the Content;
                  </p>
                </li>
                <li>
                  <p>
                    (j) Decompiles, reverse engineers, or otherwise attempts to
                    obtain the source code or underlying ideas or information of
                    or relating to the Services.
                  </p>
                </li>
              </ol>
              <p>
                <br />
              </p>
              <p>
                A violation of any of the foregoing is grounds for termination
                of your right to use or access the Services.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>YOUR RIGHTS IN THE SERVICES</strong>
              </h3>
              <p>
                The materials displayed or performed or available on or through
                the Services, including, but not limited to, text, graphics,
                data, photos, images, illustrations, User Submissions (as
                defined below), and so forth (all of the foregoing, the
                “Content”) are protected by copyright and/or other intellectual
                property laws.&nbsp; You promise to abide by all copyright
                notices, trademark rules, information, and restrictions
                contained in any Content you access through the Services, and
                you won’t use, copy, reproduce, modify, translate, publish,
                broadcast, transmit, distribute, perform, upload, display,
                license, sell, commercialize or otherwise exploit for any
                purpose any Content not owned by you, (i) without the prior
                consent of the owner of that Content or (ii) in a way that
                violates someone else’s (including Company’s) rights.
              </p>
              <p>
                <br />
              </p>
              <p>
                Subject to these Terms, we grant each user of the Services a
                worldwide, non-exclusive, non-sublicenseablesublicensable and
                non-transferable license to use (i.e., to download and display
                locally) Content solely for purposes of using the
                Services.&nbsp; Use, reproduction, modification, distribution or
                storage of any Content for any purpose other than using the
                Services is expressly prohibited without prior written
                permission from us.&nbsp; You understand that Company owns the
                Services. You won’t modify, publish, transmit, participate in
                the transfer or sale of, reproduce (except as expressly provided
                in this Section), create derivative works based on, or otherwise
                exploit any of the Services.&nbsp; The Services may allow you to
                copy or download certain Content, but please remember that even
                where these functionalities exist, all the restrictions in this
                section still apply.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>LICENSE GRANTS</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                <em>User Submissions</em>
              </p>
              <p>
                <br />
              </p>
              <p>
                Anything you post, upload, share, store, or otherwise provide
                through the Services is your “User Submission.”&nbsp; Some User
                Submissions are viewable by other users[, and if you are an
                Individual who is invited, added or authorized to use our
                Services by an Organization, that Organization may be able to
                designate which User Submissions you may view and who may access
                your User Submissions].&nbsp; You are solely responsible for all
                User Submissions you contribute to the Services.&nbsp; You
                represent that all User Submissions submitted by you are
                accurate, complete, up-to-date, and in compliance with all
                applicable laws, rules and regulations.
              </p>
              <p>
                <br />
              </p>
              <p>
                <em>Licenses</em>
              </p>
              <p>
                <br />
              </p>
              <p>
                In order to display your User Submissions on the Services, and
                to allow other users to access them (where applicable), you
                grant us certain rights in those User Submissions (see below for
                more information).&nbsp; Please note that all of the following
                licenses are subject to our{" "}
                <a
                  href="https://swiftlane.com/privacy"
                  hrefLang="en-us"
                  rel="alternate"
                >
                  Privacy Policy
                </a>{" "}
                [insert link] to the extent they relate to User Submissions that
                are also your personally-identifiable information.
              </p>
              <p>
                <br />
              </p>
              <p>
                For all User Submissions, you hereby grant Company a license to
                translate, modify (for technical purposes, for example making
                sure your content is viewable on an iPhone as well as a
                computer) and reproduce and otherwise act with respect to such
                User Submissions, in each case to enable us to operate the
                Services, as described in more detail below.&nbsp; This is a
                license only – your ownership in User Submissions is not
                affected.
              </p>
              <p>
                <br />
              </p>
              <p>
                If you store a User Submission in your own personal Company
                account and it is designated such that it is not viewable by any
                other user except you (a “Personal User Submission”), you grant
                Company the license above, as well as a license to display,
                perform, and distribute your Personal User Submission for the
                sole purpose of making that Personal User Submission accessible
                to you and providing the Services necessary to do so.
              </p>
              <p>
                <br />
              </p>
              <p>
                If you upload or share a User Submission and it is designated
                such that only certain specified users can view (for example, a
                private scan to one or more other users) (a “Limited Audience
                User Submission”), then you grant Company the licenses above, as
                well as a license to display, perform, and distribute your
                Limited Audience User Submission for the sole purpose of making
                that Limited Audience User Submission accessible to such other
                specified users, and providing the Services necessary to do
                so.&nbsp; Also, you grant such other specified users a license
                to access that Limited Audience User Submission, and to use and
                exercise all rights in it, as permitted by the functionality of
                the Services.
              </p>
              <p>
                <br />
              </p>
              <p>
                If you upload or share a User Submission publicly on the
                Services, or if you provide us (in a direct email or otherwise)
                with any feedback, suggestions, improvements, enhancements,
                and/or feature requests relating to the Services (each of the
                foregoing, a “Public User Submission”), then you grant Company
                the licenses above, as well as a license to display, perform,
                and distribute your Public User Submission for the purpose of
                making that Public User Submission accessible to all Company
                users and providing the Services necessary to do so, as well as
                all other rights necessary to use and exercise all rights in
                that Public User Submission in connection with the Services
                and/or otherwise in connection with Company’s business.&nbsp;
                Also, you grant all other users of the Services a license to
                access that Public User Submission, and to use and exercise all
                rights in it, as permitted by the functionality of the Services.
              </p>
              <p>
                <br />
              </p>
              <p>
                You agree that the licenses you grant are royalty-free,
                perpetual, sublicenseable, irrevocable, and worldwide, provided
                that when you delete your Company account, we will stop
                displaying your User Submissions (other than Public User
                Submissions, which may remain fully available) to other users
                (if applicable), but you understand and agree that it may not be
                possible to completely delete that content from Company’s
                records, and that your User Submissions may remain viewable
                elsewhere to the extent that they were copied or stored by other
                users.
              </p>
              <p>
                <br />
              </p>
              <p>
                For all User Submissions, you also grant Company the right to
                internally use and modify the User Submissions for the purposes
                of generating Aggregated Anonymous Data (as defined below) and
                to freely use and make available such Aggregated Anonymous Data
                for Company’s business purposes (including, without limitation,
                for purposes of improving, testing, operating, promoting and
                marketing Company’s Services).&nbsp; “Aggregated Anonymous Data”
                means data submitted to, collected by or generated by Company in
                connection with your use of the Services, but only in aggregate,
                anonymized form which can in no way be linked specifically to
                you.&nbsp;{" "}
                <strong>
                  Notwithstanding anything to the contrary, and other than for
                  use as Aggregated Anonymous Data, for any and all User
                  Submissions that contain your biometric data, you grant
                  Company a license to use, modify, display, reproduce and
                  distribute that submission only for the purpose of allowing
                  Company to render the Services to you (and only to the extent
                  necessary to do so).&nbsp;
                </strong>
              </p>
              <p>
                <br />
              </p>
              <p>
                Finally, you understand and agree that Company, in performing
                the required technical steps to provide the Services to our
                users (including you), may need to make changes to your User
                Submissions to conform and adapt those User Submissions to the
                technical requirements of connection networks, devices,
                services, or media, and the foregoing licenses include the
                rights to do so.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>COPYRIGHT INFRINGEMENT</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                You may have heard of the Digital Millennium Copyright Act (the
                “DMCA”), as it relates to online service providers being asked
                to remove material that allegedly violates someone’s
                copyright.&nbsp; We respect others’ intellectual property
                rights, and we reserve the right to delete or disable Content
                alleged to be infringing, and to terminate the accounts of
                repeat alleged infringers; to review our complete Copyright
                Dispute Policy and learn how to report potentially infringing
                content, click here [insert link to Copyright Dispute
                Policy].&nbsp; To learn more about the DMCA, click{" "}
                <a
                  href="http://www.copyright.gov/legislation/dmca.pdf"
                  hrefLang="en-us"
                  rel="alternate"
                >
                  here
                </a>
                . &nbsp;
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>YOUR RESPONSIBILITIES</strong>
              </h3>
              <p>
                Any information or content publicly posted or privately
                transmitted through the Services is the sole responsibility of
                the person from whom such content originated, and you access all
                such information and Content at your own risk, and we aren’t
                liable for any errors or omissions in that information or
                Content or for any damages or loss you might suffer in
                connection with it. &nbsp; We cannot control and have no duty to
                take any action regarding how you may interpret and use the
                Content or what actions you may take as a result of having been
                exposed to the Content, and you hereby release us from all
                liability for you having acquired or not acquired Content
                through the Services.&nbsp; We can’t guarantee the identity of
                any users with whom you interact in using the Services and are
                not responsible for which users gain access to the Services.
              </p>
              <p>
                <br />
              </p>
              <p>
                You are responsible for all Content you contribute, in any
                manner, to the Services, and you represent and warrant you have
                all rights necessary to do so, in the manner in which you
                contribute it. &nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                The Services may contain links or connections to third party
                websites or services that are not owned or controlled by
                Company. When you access third party websites or use third party
                services, you accept that there are risks in doing so, and that
                Company is not responsible for such risks. &nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                Company has no control over, and assumes no responsibility for,
                the content, accuracy, privacy policies, or practices of or
                opinions expressed in any third party websites or by any third
                party that you interact with through the Services. In addition,
                Company will not and cannot monitor, verify, censor or edit the
                content of any third party site or service. We encourage you to
                be aware when you leave the Services and to read the terms and
                conditions and privacy policy of each third party website or
                service that you visit or utilize. By using the Services, you
                release and hold us harmless from any and all liability arising
                from your use of any third party website or service.
              </p>
              <p>
                <br />
              </p>
              <p>
                Your interactions with organizations and/or individuals found on
                or through the Services, including payment and delivery of goods
                or services, and any other terms, conditions, warranties or
                representations associated with such dealings, are solely
                between you and such organizations and/or individuals. You
                should make whatever investigation you feel necessary or
                appropriate before proceeding with any online or offline
                transaction with any of these third parties. You agree that
                Company shall not be responsible or liable for any loss or
                damage of any sort incurred as the result of any such dealings.
              </p>
              <p>
                <br />
              </p>
              <p>
                If there is a dispute between participants on this site, or
                between users and any third party, you agree that Company is
                under no obligation to become involved. In the event that you
                have a dispute with one or more other users, you release
                Company, its directors, officers, employees, agents, and
                successors from claims, demands, and damages of every kind or
                nature, known or unknown, suspected or unsuspected, disclosed or
                undisclosed, arising out of or in any way related to such
                disputes and/or our Services. You shall and hereby do waive
                California Civil Code Section 1542 or any similar law of any
                jurisdiction, which says in substance: "A general release does
                not extend to claims that the creditor or releasing party does
                not know or suspect to exist in his or her favor at the time of
                executing the release and that, if known by him or her, would
                have materially affected his or her settlement with the debtor
                or released party."
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>CHANGES TO THE SERVICES</strong>
              </h3>
              <p>
                We’re always trying to improve our Services, so they may change
                over time.&nbsp; We may suspend or discontinue any part of the
                Services, or we may introduce new features or impose limits on
                certain features or restrict access to parts or all of the
                Services.&nbsp; We’ll try to give you notice when we make a
                material change to the Services that would adversely affect you,
                but this isn’t always practical.&nbsp; We reserve the right to
                remove any Content from the Services at any time, for any reason
                (including, but not limited to, if someone alleges you
                contributed that Content in violation of these Terms), in our
                sole discretion, and without notice.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>PAYMENT FOR THE SERVICES</strong>
              </h3>
              <p>
                We currently provide the Services at no extra charge to
                Individuals, however, we reserve the right to charge for certain
                or all Services in the future.&nbsp; We will notify you before
                any Services you are then using begin carrying a fee, and if you
                wish to continue using such Services, you must pay all
                applicable fees for such Services.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>STOPPING THE SERVICES</strong>
              </h3>
              <p>
                You’re free to stop using the Services at any time by contacting
                us at&nbsp; contact@swiftlane.com[insert contact]; please refer
                to our Privacy Policy https://swiftlane.com/privacy[insert link]
                as well as the licenses above, to understand how we treat
                information you provide to us after you have stopped using our
                Services. [Note that if you are an Individual who was invited,
                added or authorized to use the Services by an Organization, we
                may notify that Organization of your deletion request.]
              </p>
              <p>
                <br />
              </p>
              <p>
                Swiftlane is also free to terminate (or suspend access to) your
                use of the Services or your account for any reason in our
                discretion, including your breach of these Terms.&nbsp;
                Swiftlane has the sole right to decide whether you are in
                violation of any of the restrictions set forth in these
                Terms.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                Account termination may result in destruction of any Content
                associated with your account, so keep that in mind before you
                decide to terminate your account.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                If you have deleted your account by mistake, contact us
                immediately at [insert contact]contact@swiftlane.com – we will
                try to help, but unfortunately, we can’t promise that we can
                recover or restore anything.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                Provisions that, by their nature, should survive termination of
                these Terms shall survive termination.&nbsp; By way of example,
                all of the following will survive termination: any obligation
                you have to pay us or indemnify us, any limitations on our
                liability, any terms regarding ownership or intellectual
                property rights, and terms regarding disputes between us,
                including without limitation the arbitration agreement.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>Mobile Applications</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                You acknowledge and agree that the availability of our mobile
                application is dependent on the third party stores from which
                you download the application, e.g., the App Store from Apple or
                the Android app market from Google (each an “App Store”). Each
                App Store may have its own terms and conditions to which you
                must agree before downloading mobile applications from such
                store, including the specific terms relating to Apple App Store
                set forth below. You agree to comply with, and your license to
                use our application is conditioned upon your compliance with,
                such App Store terms and conditions. To the extent such other
                terms and conditions from such App Store are less restrictive
                than, or otherwise conflict with, the terms and conditions of
                these Terms, the more restrictive or conflicting terms and
                conditions in these Terms apply.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>Apple App Store Terms</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                These Terms apply to your use of all the Services, including our
                iOS applications (the “Application”) available via the Apple,
                Inc. (“Apple”) App Store, but the following additional terms
                also apply to the Application:
              </p>
              <ol data-rte-list="default">
                <li>
                  <p>
                    (a) Both you and Swiftlane acknowledge that the Terms are
                    concluded between you and Swiftlane only, and not with
                    Apple, and that Apple is not responsible for the Application
                    or the Content;
                  </p>
                </li>
                <li>
                  <p>
                    (b) The Application is licensed to you on a limited,
                    non-exclusive, non-transferrable, non-sublicensable basis,
                    solely to be used in connection with the Services for your
                    private, personal, non-commercial use, subject to all the
                    terms and conditions of these Terms as they are applicable
                    to the Services;
                  </p>
                </li>
                <li>
                  <p>
                    (c) You will only use the Application in connection with an
                    Apple device that you own or control;
                  </p>
                </li>
                <li>
                  <p>
                    (d) You acknowledge and agree that Apple has no obligation
                    whatsoever to furnish any maintenance and support services
                    with respect to the Application;
                  </p>
                </li>
                <li>
                  <p>
                    (e) In the event of any failure of the Application to
                    conform to any applicable warranty, including those implied
                    by law, you may notify Apple of such failure; upon
                    notification, Apple’s sole warranty obligation to you will
                    be to refund to you the purchase price, if any, of the
                    Application;
                  </p>
                </li>
                <li>
                  <p>
                    (f) You acknowledge and agree that Swiftlane, and not Apple,
                    is responsible for addressing any claims you or any third
                    party may have in relation to the Application;
                  </p>
                </li>
                <li>
                  <p>
                    (g) You acknowledge and agree that, in the event of any
                    third-party claim that the Application or your possession
                    and use of the Application infringes that third party’s
                    intellectual property rights, Swiftlane, and not Apple, will
                    be responsible for the investigation, defense, settlement
                    and discharge of any such infringement claim;
                  </p>
                </li>
                <li>
                  <p>
                    (h) You represent and warrant that you are not located in a
                    country subject to a U.S. Government embargo, or that has
                    been designated by the U.S. Government as a “terrorist
                    supporting” country, and that you are not listed on any U.S.
                    Government list of prohibited or restricted parties;
                  </p>
                </li>
                <li>
                  <p>
                    (i) Both you and Swiftlane acknowledge and agree that, in
                    your use of the Application, you will comply with any
                    applicable third-party terms of agreement which may affect
                    or be affected by such use; and
                  </p>
                </li>
                <li>
                  <p>
                    (j) Both you and Swiftlane acknowledge and agree that Apple
                    and Apple’s subsidiaries are third-party beneficiaries of
                    these Terms, and that upon your acceptance of these Terms,
                    Apple will have the right (and will be deemed to have
                    accepted the right) to enforce these Terms against you as
                    the third-party beneficiary hereof.
                  </p>
                </li>
              </ol>
              <p>
                <br />
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>WARRANTY DISCLAIMER&nbsp;</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                Swiftlane and its licensors, suppliers, partners, parent,
                subsidiaries or affiliated entities, and each of their
                respective officers, directors, members, employees, consultants,
                contract employees, representatives and agents, and each of
                their respective successors and assigns (Swiftlane and all such
                parties together, the “Swiftlane Parties”) make no
                representations or warranties concerning the Services, including
                without limitation regarding any Content contained in or
                accessed through the Services, and the Swiftlane Parties will
                not be responsible or liable for the accuracy, copyright
                compliance, legality, or decency of material contained in or
                accessed through the Services or any claims, actions, suits
                procedures, costs, expenses, damages or liabilities arising out
                of use of, or in any way related to your participation in, the
                Services. The Swiftlane Parties make no representations or
                warranties regarding suggestions or recommendations of services
                or products offered or purchased through or in connection with
                the Services. THE SERVICES AND CONTENT ARE PROVIDED BY SWIFTLANE
                (AND ITS LICENSORS AND SUPPLIERS) ON AN “AS-IS” BASIS, WITHOUT
                WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING,
                WITHOUT LIMITATION, IMPLIED WARRANTIES OF MERCHANTABILITY,
                FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR THAT USE
                OF THE SERVICES WILL BE UNINTERRUPTED OR ERROR-FREE. SOME STATES
                DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS,
                SO THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>LIMITATION OF LIABILITY</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                TO THE FULLEST EXTENT ALLOWED BY APPLICABLE LAW, UNDER NO
                CIRCUMSTANCES AND UNDER NO LEGAL THEORY (INCLUDING, WITHOUT
                LIMITATION, TORT, CONTRACT, STRICT LIABILITY, OR OTHERWISE)
                SHALL ANY OF THE SWIFTLANE PARTIES BE LIABLE TO YOU OR TO ANY
                OTHER PERSON FOR (A) ANY INDIRECT, SPECIAL, INCIDENTAL, PUNITIVE
                OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING DAMAGES FOR LOST
                PROFITS, BUSINESS INTERRUPTION, LOSS OF DATA, LOSS OF GOODWILL,
                WORK STOPPAGE, ACCURACY OF RESULTS, OR COMPUTER FAILURE OR
                MALFUNCTION, (B) ANY SUBSTITUTE GOODS, SERVICES OR TECHNOLOGY,
                (C) ANY AMOUNT, IN THE AGGREGATE, IN EXCESS OF THE GREATER OF
                (I) ONE-HUNDRED ($100) DOLLARS OR (II) THE AMOUNTS PAID AND/OR
                PAYABLE BY YOU TO SWIFTLANE IN CONNECTION WITH THE SERVICES IN
                THE TWELVE (12) MONTH PERIOD PRECEDING THIS APPLICABLE CLAIM OR
                (D) ANY MATTER BEYOND OUR REASONABLE CONTROL. SOME STATES DO NOT
                ALLOW THE EXCLUSION OR LIMITATION OF INCIDENTAL OR CONSEQUENTIAL
                OR CERTAIN OTHER DAMAGES, SO THE ABOVE LIMITATION AND EXCLUSIONS
                MAY NOT APPLY TO YOU.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>INDEMNIFICATION</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                You agree to indemnify and hold the Swiftlane Parties harmless
                from and against any and all claims, liabilities, damages
                (actual and consequential), losses and expenses (including
                attorneys’ fees) arising from or in any way related to any
                claims relating to (a) your use of the Services (including any
                actions taken by a third party using your account), and (b) your
                violation of these Terms. In the event of such a claim, suit, or
                action (“Claim”), we will attempt to provide notice of the Claim
                to the contact information we have for your account (provided
                that failure to deliver such notice shall not eliminate or
                reduce your indemnification obligations hereunder).
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>ASSIGNMENT</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                You may not assign, delegate or transfer these Terms or your
                rights or obligations hereunder, or your Services account, in
                any way (by operation of law or otherwise) without Swiftlane's
                prior written consent. We may transfer, assign, or delegate
                these Terms and our rights and obligations without consent.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>CHOICE OF LAW</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                These Terms are governed by and will be construed under the
                Federal Arbitration Act, applicable federal law, and the laws of
                the State of California, without regard to the conflicts of laws
                provisions thereof.
              </p>
              <p>
                <br />
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>ARBITRATION AGREEMENT</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                Please read the following ARBITRATION AGREEMENT carefully
                because it requires you to arbitrate certain disputes and claims
                with Swiftlane and limits the manner in which you can seek
                relief from Swiftlane. Both you and Swiftlane acknowledge and
                agree that for the purposes of any dispute arising out of or
                relating to the subject matter of these Terms, Swiftlane's
                officers, directors, employees and independent contractors
                (“Personnel”) are third-party beneficiaries of these Terms, and
                that upon your acceptance of these Terms, Personnel will have
                the right (and will be deemed to have accepted the right) to
                enforce these Terms against you as the third-party beneficiary
                hereof.
              </p>
              <p>
                <br />
              </p>
              <p>
                <em>
                  (a) Arbitration Rules; Applicability of Arbitration Agreement
                </em>
                . The parties shall use their best efforts to settle any
                dispute, claim, question, or disagreement arising out of or
                relating to the subject matter of these Terms directly through
                good-faith negotiations, which shall be a precondition to either
                party initiating arbitration. If such negotiations do not
                resolve the dispute, it shall be finally settled by binding
                arbitration in San Francisco County, California. The arbitration
                will proceed in the English language, in accordance with the
                JAMS Streamlined Arbitration Rules and Procedures (the “Rules”)
                then in effect, by one commercial arbitrator with substantial
                experience in resolving intellectual property and commercial
                contract disputes. The arbitrator shall be selected from the
                appropriate list of JAMS arbitrators in accordance with such
                Rules. Judgment upon the award rendered by such arbitrator may
                be entered in any court of competent jurisdiction.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                (b) <em>Costs of Arbitration</em>. The Rules will govern payment
                of all arbitration fees. Swiftlane will pay all arbitration fees
                for claims less than seventy-five thousand ($75,000) dollars.
                Swiftlane will not seek its attorneys’ fees and costs in
                arbitration unless the arbitrator determines that your claim is
                frivolous.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                (c) <em>Small Claims Court; Infringement</em>. Either you or
                Swiftlane may assert claims, if they qualify, in small claims
                court in San Francisco County, California or any United States
                county where you live or work. Furthermore, notwithstanding the
                foregoing obligation to arbitrate disputes, each party shall
                have the right to pursue injunctive or other equitable relief at
                any time, from any court of competent jurisdiction, to prevent
                the actual or threatened infringement, misappropriation or
                violation of a party's copyrights, trademarks, trade secrets,
                patents or other intellectual property rights.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                (d) <em>Waiver of Jury Trial</em>. YOU AND SWIFTLANE WAIVE ANY
                CONSTITUTIONAL AND STATUTORY RIGHTS TO GO TO COURT AND HAVE A
                TRIAL IN FRONT OF A JUDGE OR JURY. You and Swiftlane are instead
                choosing to have claims and disputes resolved by arbitration.
                Arbitration procedures are typically more limited, more
                efficient, and less costly than rules applicable in court and
                are subject to very limited review by a court. In any litigation
                between you and Swiftlane over whether to vacate or enforce an
                arbitration award, YOU AND SWIFTLANE WAIVE ALL RIGHTS TO A JURY
                TRIAL, and elect instead to have the dispute be resolved by a
                judge.
              </p>
              <p>
                <br />
              </p>
              <p>
                (e) <em>Waiver of Class or Consolidated Actions</em>. ALL CLAIMS
                AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION AGREEMENT MUST
                BE ARBITRATED OR LITIGATED ON AN INDIVIDUAL BASIS AND NOT ON A
                CLASS BASIS. CLAIMS OF MORE THAN ONE CUSTOMER OR USER CANNOT BE
                ARBITRATED OR LITIGATED JOINTLY OR CONSOLIDATED WITH THOSE OF
                ANY OTHER CUSTOMER OR USER. If however, this waiver of class or
                consolidated actions is deemed invalid or unenforceable, neither
                you nor Swiftlane is entitled to arbitration; instead all claims
                and disputes will be resolved in a court as set forth in (g)
                below.<strong>&nbsp;</strong>
              </p>
              <p>
                <br />
              </p>
              <p>
                (f) <em>Opt-out</em>. You have the right to opt out of the
                provisions of this Section by sending written notice of your
                decision to opt out to the following address: [Enter address]65
                Langton St, San Francisco, CA, 94103 postmarked within thirty
                (30) days of first accepting these Terms. You must include (i)
                your name and residence address, (ii) the email address and/or
                telephone number associated with your account, and (iii) a clear
                statement that you want to opt out of these Terms’ arbitration
                agreement.
              </p>
              <p>
                <br />
              </p>
              <p>
                (g) <em>Exclusive Venue</em>. If you send the opt-out notice in
                (f), and/or in any circumstances where the foregoing arbitration
                agreement permits either you or Swiftlane to litigate any
                dispute arising out of or relating to the subject matter of
                these Terms in court, then the foregoing arbitration agreement
                will not apply to either party, and both you and Swiftlane agree
                that any judicial proceeding (other than small claims actions)
                will be brought in the state or federal courts located in,
                respectively, San Francisco County, California, or the federal
                district in which that county falls.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                (h) <em>Severability</em>. If the prohibition against class
                actions and other claims brought on behalf of third parties
                contained above is found to be unenforceable, then all of the
                preceding language in this Arbitration Agreement section will be
                null and void. This arbitration agreement will survive the
                termination of your relationship with Swiftlane.
              </p>
              <p>
                <br />
              </p>
              <h3>
                <strong>MISCELLANEOUS</strong>
              </h3>
              <p>
                <br />
              </p>
              <p>
                You will be responsible for paying, withholding, filing, and
                reporting all taxes, duties, and other governmental assessments
                associated with your activity in connection with the Services,
                provided that the Swiftlane may, in its sole discretion, do any
                of the foregoing on your behalf or for itself as it sees fit.
                The failure of either you or us to exercise, in any way, any
                right herein shall not be deemed a waiver of any further rights
                hereunder. If any provision of these Terms are found to be
                unenforceable or invalid, that provision will be limited or
                eliminated, to the minimum extent necessary, so that these Terms
                shall otherwise remain in full force and effect and enforceable.
                You and Swiftlane agree that these Terms are the complete and
                exclusive statement of the mutual understanding between you and
                Swiftlane, and that these Terms supersede and cancel all
                previous written and oral agreements, communications and other
                understandings relating to the subject matter of these Terms.
                You hereby acknowledge and agree that you are not an employee,
                agent, partner, or joint venture of Swiftlane, and you do not
                have any authority of any kind to bind Swiftlane in any respect
                whatsoever.&nbsp;
              </p>
              <p>
                <br />
              </p>
              <p>
                Except as expressly set forth in the sections above regarding
                the Apple Application and the arbitration agreement, you and
                Swiftlane agree there are no third-party beneficiaries intended
                under these Terms.
              </p>
              <p>
                <br />
              </p>
              <p>
                <br />
              </p>
            </div>
          </div>
          <Footer />
        </Layout>
      </div>
    )
  }
}

export default ThankYou
